import {
  KUBERNETES_DISCOVERY_REQ,
  KUBERNETES_DISCOVERY_SUCCESS,
  KUBERNETES_DISCOVERY_ERROR,
  KUBERNETES_DISCOVERY_CLUSTERS_REQ,
  KUBERNETES_DISCOVERY_CLUSTERS_SUCCESS,
  KUBERNETES_DISCOVERY_CLUSTERS_ERROR
} from './kubernetes-discovery.type'

import { kubernetesDiscoveryMetaInfo } from '@/column-header/hosts/kubernetesdiscovery-meta'
import IQCollection from '@/resources/collections/IQCollection'
import ApiRest from '@/api/api-rest'
import { OrderByEnum } from '@/constants/orderby.constants'

const state = {
  kubernetesDiscoveryListReqStatus: '',
  kubernetesDiscoveryList: {},
  kubernetesDiscoveryClustersReqStatus: '',
  kubernetesDiscoveryClusters: {}
}

const getters = {
  kubernetesDiscoveryList: state => state.kubernetesDiscoveryList,
  kubernetesDiscoveryListReqStatus: state => state.kubernetesDiscoveryListReqStatus,
  kubernetesDiscoveryClusters: state => state.kubernetesDiscoveryClusters,
  kubernetesDiscoveryClustersReqStatus: state => state.kubernetesDiscoveryClustersReqStatus
}

// Best Practice - updates state
const mutations = {
  [KUBERNETES_DISCOVERY_REQ]: state => {
    state.kubernetesDiscoveryListReqStatus = 'loading'
  },
  [KUBERNETES_DISCOVERY_SUCCESS]: (state, data) => {
    state.kubernetesDiscoveryListReqStatus = 'saved'
    state.kubernetesDiscoveryList = data
  },
  [KUBERNETES_DISCOVERY_ERROR]: (state, errMsg) => {
    state.kubernetesDiscoveryListReqStatus = 'error'
  },
  [KUBERNETES_DISCOVERY_CLUSTERS_REQ]: state => {
    state.kubernetesDiscoveryClustersReqStatus = 'loading'
  },
  [KUBERNETES_DISCOVERY_CLUSTERS_SUCCESS]: (state, data) => {
    state.kubernetesDiscoveryClustersReqStatus = 'saved'
    state.kubernetesDiscoveryClusters = data
  },
  [KUBERNETES_DISCOVERY_CLUSTERS_ERROR]: (state, errMsg) => {
    state.kubernetesDiscoveryClustersReqStatus = 'error'
  }
}

// Best Practice - actions call mutations
// make api call and commit states
const actions = {
  [KUBERNETES_DISCOVERY_REQ] (context) {
    return new Promise((resolve, reject) => {
      context.commit(KUBERNETES_DISCOVERY_REQ)
      ApiRest()
        .get('/kubernetesdiscovery')
        .then(({ data }) => {
          data = _.map(data, k8 => {
            k8.containerIds = _.map(k8.k8sContainerList, 'containerId')
            return k8
          })
          let allAgents = new IQCollection(
            data,
            { attributes: kubernetesDiscoveryMetaInfo.meta.columns },
            { defaultSort: 'clusterName', sortOrder: OrderByEnum.ASC }
          )

          context.commit(KUBERNETES_DISCOVERY_SUCCESS, allAgents)
          resolve(allAgents)
        })
        .catch(errMsg => {
          context.commit(KUBERNETES_DISCOVERY_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [KUBERNETES_DISCOVERY_CLUSTERS_REQ] (context) {
    return new Promise((resolve, reject) => {
      context.commit(KUBERNETES_DISCOVERY_CLUSTERS_REQ)
      ApiRest()
        .get('/kubernetesdiscovery/allclusters')
        .then(({ data }) => {
          data = _.map(data, kubenetes => {
            kubenetes.uuid = `${kubenetes.name}${kubenetes.region}${kubenetes.uniqueId}`
            return kubenetes
          })
          context.commit(KUBERNETES_DISCOVERY_CLUSTERS_SUCCESS, data)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(KUBERNETES_DISCOVERY_CLUSTERS_ERROR, errMsg)
          reject(errMsg)
        })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/agents/kubernetes-discovery.module.js